// All of the requested modules are loaded behind enumerable getters.
const map = Object.defineProperties({}, {
  "./board-column.js": { enumerable: true, get() { return require("/home/dev/awesome-tasks/releases/20261103111801/frontend/src/models/board-column.js"); } },
  "./board.js": { enumerable: true, get() { return require("/home/dev/awesome-tasks/releases/20261103111801/frontend/src/models/board.js"); } },
  "./comment.js": { enumerable: true, get() { return require("/home/dev/awesome-tasks/releases/20261103111801/frontend/src/models/comment.js"); } },
  "./option.js": { enumerable: true, get() { return require("/home/dev/awesome-tasks/releases/20261103111801/frontend/src/models/option.js"); } },
  "./project-replica-registry-entry.js": { enumerable: true, get() { return require("/home/dev/awesome-tasks/releases/20261103111801/frontend/src/models/project-replica-registry-entry.js"); } },
  "./project.js": { enumerable: true, get() { return require("/home/dev/awesome-tasks/releases/20261103111801/frontend/src/models/project.js"); } },
  "./replica-metadata.js": { enumerable: true, get() { return require("/home/dev/awesome-tasks/releases/20261103111801/frontend/src/models/replica-metadata.js"); } },
  "./sync.js": { enumerable: true, get() { return require("/home/dev/awesome-tasks/releases/20261103111801/frontend/src/models/sync.js"); } },
  "./task-assigned-user.js": { enumerable: true, get() { return require("/home/dev/awesome-tasks/releases/20261103111801/frontend/src/models/task-assigned-user.js"); } },
  "./task-board.js": { enumerable: true, get() { return require("/home/dev/awesome-tasks/releases/20261103111801/frontend/src/models/task-board.js"); } },
  "./task-type.js": { enumerable: true, get() { return require("/home/dev/awesome-tasks/releases/20261103111801/frontend/src/models/task-type.js"); } },
  "./task.js": { enumerable: true, get() { return require("/home/dev/awesome-tasks/releases/20261103111801/frontend/src/models/task.js"); } },
  "./timelog.js": { enumerable: true, get() { return require("/home/dev/awesome-tasks/releases/20261103111801/frontend/src/models/timelog.js"); } },
  "./user.js": { enumerable: true, get() { return require("/home/dev/awesome-tasks/releases/20261103111801/frontend/src/models/user.js"); } },
});

function metroContext(request) {
    return map[request];
}

// Return the keys that can be resolved.
metroContext.keys = function metroContextKeys() {
  return Object.keys(map);
};

// Return the module identifier for a user request.
metroContext.resolve = function metroContextResolve(request) {
  throw new Error('Unimplemented Metro module context functionality');
}

module.exports = metroContext;